import { ACTIVE_STATUS, ARCHIVE_STATUS } from "models/checkpoint";
import PropTypes from "prop-types";
import React from "react";
import { Status as StatusUI } from "@weezevent/nacre";
import { useTranslation } from "react-i18next";

const Status = ({ status, ...rest }) => {
	const { t } = useTranslation();

	if (status === ARCHIVE_STATUS) {
		return <StatusUI text={t("access.common.archived")} {...rest} />;
	}

	return (
		<StatusUI
			color={status === ACTIVE_STATUS ? "green" : "red"}
			text={
				status === ACTIVE_STATUS
					? t("access.checkpoint.on")
					: t("access.checkpoint.off")
			}
			{...rest}
		/>
	);
};

Status.propTypes = {
	status: PropTypes.oneOfType([PropTypes.number, PropTypes.string])
};

Status.defaultProps = {
	status: 0
};

export default React.memo(Status);
